// extracted by mini-css-extract-plugin
export default {"container":"LocalCommitteeEB_container__Y8Ryp","ebPerson":"LocalCommitteeEB_ebPerson__lQizu","ebInfoSection":"LocalCommitteeEB_ebInfoSection__g1wx3"};